/* eslint-disable prefer-promise-reject-errors */
import config from 'src/config';
import { deleteRequest, postRequest, putRequest } from 'src/utils/RequestUtil';

export const caseSearchAPI = function (data) {
    const url = `${config.baseUrl}case/search`;
    return postRequest({
        url,
        data,
    });
};

export const casesForExcelApi = function (data) {
    
    const url = `${config.baseUrl}case/excelSearch`;
    let response =postRequest({
        url,
        data,
    });
  
    return response

};
export const pipelineApi = function (data) {
    const url = `${config.baseUrl}case/pipeline`;
    let response =postRequest({
        url,
        data,
    });
  
    return response
};
export const dashBoardPipelineApi = function (data) {
    const url = `${config.baseUrl}case/dashBoard/pipeline`;
    let response =postRequest({
        url,
        data,
    });
  
    return response
};
export const companyWiseCaseCountPipeline = function(data){
    const url = `${config.baseUrl}case/pipeline/Sales`;
    let response =postRequest({
        url,
        data: {
            ...data,
            sortBy: 'companyName',  // or another timestamp field
            sortOrder: 1,  // ascending order
        },
    });
    return response;
}
export const ManagerAgentMonthWiseCases = function(data){
    const url = `${config.baseUrl}case/pipeline/ManagerAgentMonthWiseCases`;
    let response =postRequest({
        url,
        data: {
            ...data,
            sortBy: 'reportingManagerBackendId',  // or another timestamp field
            sortOrder: 1,  // ascending order
        },
    });
    return response;
}
export const caseCreateAPI = function (data) {
    const url = `${config.baseUrl}case`;
    return postRequest({
        url,
        data,
    });
};

export const caseUpdateAPI = function ({
    caseId,
    data,
}) {
    const url = `${config.baseUrl}case/${caseId}`;
    return putRequest({
        url,
        data,
    });
};


export const caseInvoiceCreateAPI = function (data) {
    const url = `${config.baseUrl}case/invoice`;
    return postRequest({
        url,
        data,
    });
};
export const caseReceiptCreateAPI = function (caseId, data) {
    const url = `${config.baseUrl}case/receipt/${caseId}`;
    return putRequest({
        url,
        data,
    });
};
export const casePaymentCreateAPI = function (caseId, data) {
    const url = `${config.baseUrl}case/payment/${caseId}`;
    return putRequest({
        url,
        data,
    });
};
export const coApplicantDeleteAPI = function ({
    caseId,
    _id
}) {
    const url = `${config.baseUrl}case/co-applicant/${caseId}/${_id}`;
    return deleteRequest({
        url,
    });
};